import React from 'react'

export default function About() {
  return (
    <>
        <div id='about' className='md:px-10 px-2 max-w-screen-xl justify-center mx-auto items-center'>
            <div className='text-white mx-auto md:pt-56 md:pb-32 pt-10 justify-center items-center'>
                <div className='justify-center py-5 gap-16 items-center mx-auto'>
                    <div className='px-4'>
                        <h1 className='text-base font-semibold text-[#136690]'>
                            The Right Cybersecurity Services for The Transportation & Logistics Industry
                        </h1>
                        <h1 className='text-white md:text-4xl text-2xl justify-center pt-5 font-semibold max-w-screen-md'>
                            Meeting Transportation & Logistics Cybersecurity Challenges:
                        </h1>
                        <p className='text-[#C3CDD3] pt-4 max-w-screen-lg'>
                            The transportation and logistics industry is responsible for the movement of goods and people across the globe. With the increasing reliance on technology, cybersecurity solutions for transport have become a top priority for businesses in this industry. 
                            <br className='block lg:hidden md:hidden'/>
                            <br className='block lg:hidden md:hidden'/>
                            A cyberattack could have catastrophic consequences, such as disrupting the supply chain, delaying shipments or even leading to accidents.
                            <br className='hidden md:block lg:block'/>
                            <br className='hidden md:block lg:block'/>
                            In addition to potentially disrupting the supply chain, a cyberattack could also result in the theft of sensitive data, such as customer information or trade secrets. 
                            <br className='block lg:hidden md:hidden'/><br className='block lg:hidden md:hidden'/>
                            A data breach could have severe consequences for an a business, including damage to its reputation and financial losses.
                        </p>
                        <h1 className='md:text-xl text-xl font-semibold pt-8'>
                            What should keep you as a Transportation & Logistics Leader awake at night?
                        </h1>
                        <p className='pt-5 text-[#C3CDD3] max-w-screen-lg'>
                            Safely integrating new technologies into legacy systems.
                            Balancing security with operational efficiency.
                            Maintaining the continuity of the supply chain during incidents.
                            Standardizing cybersecurity practices across the business.
                        </p>
                        <h1 className='md:text-xl text-xl font-semibold pt-8'>
                            RockSec Group mitigating cyber risk for Transportation & Logistics Businesses.
                        </h1>
                        <p className='pt-5 text-[#C3CDD3] max-w-screen-lg'>
                            Logistics and management software
                            loT connectivity of units such as trucks, ships, planes, and rails Location and navigation systems Across the entirety of the transportation industry there are three major challenges that affects all of them. These challenges are:
                        </p>
                        <br/>
                        <p className='text-[#C3CDD3] text-sm md:pt-10'>
                            An effective approach should be consistent compliance Continuous Protection | Continuous visibility
                        </p>
                    </div>
                </div>
            </div>
        </div>
        <div className='bg-[#0D0D0D] w-full text-white md:pb-14 mt-10 md:mt-0'>
            <div className='pt-16 md:pt-44 max-w-screen-md mx-auto justify-center md:px-10 px-5'>
                <h1 className='md:text-5xl text-2xl text-center'>
                    How we help Transportation & Logistics Businesses stay secure & compliant?
                </h1>
                <p className='pt-5 md:pt-10 text-[#C3CDD3] md:max-w-screen-sm mx-auto justify-center text-center md:text-base text-sm'>
                    RockSec Group's World-class Cybersecurity services help Transportation & Logistics Businesses comply with requirements, avoid 
                    costly fines and maintain reputation.  
                </p>
            </div>
        </div>
    </>
  )
}